import yn from "yn";
import { isDevelopment } from "../utils/isDevelopment";

let serverUrl = process.env.REACT_APP_SERVER_URL || "";

if (isDevelopment && !yn(process.env.REACT_APP_DEV_URL)) {
    serverUrl = `http://${window.location.hostname}:6464`;
}

// Fake site key that always passes the captcha successfully without a challenge,
// and provides a message over the widget that it is not a valid recaptcha instance.
const DEV_SITE_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

export const SERVER_URL = serverUrl;
export const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || DEV_SITE_KEY;

